// Story 10.5 / 16.2 — `useCan(capability, botId?)`. Con `botId`, decide con las
// capabilities que el servidor devuelve con ese bot (rol en su organización).
// Sin él, con las efectivas del usuario en alguna organización (`/auth/me`):
// p. ej. "Nuevo bot" aparece si puede crear en al menos una.

import { useBot } from '@/hooks/queries/use-bots';
import { useMe } from '@/hooks/queries/use-me';
import { type Capability, hasPermission, isUserRole } from '@/lib/permissions';

export function useCan(capability: Capability, botId?: number): boolean {
  const { data: me } = useMe();
  const { data: bot } = useBot(botId ?? 0, botId != null);
  if (botId != null) return bot?.capabilities?.includes(capability) ?? false;
  if (me?.capabilities) return me.capabilities.includes(capability);
  return hasPermission(isUserRole(me?.role) ? me.role : null, capability);
}
